import { commitMutation } from 'api/graphql'
import { readInlineData } from 'react-relay'
import { graphql } from 'relay-runtime'
import { isPrerendering } from 'services/prerender'
import { masq_masqAsUserMutation } from '__generated__/masq_masqAsUserMutation.graphql'
import { masq_unmasqMutation } from '__generated__/masq_unmasqMutation.graphql'
import { masq_masqAsUser$key } from '__generated__/masq_masqAsUser.graphql'

/**
 * Does a hard reload of the app
 */
function hardReloadApp() {
  const w = window as any
  w.location = '/'
}

/**
 * Masks as the given user, allowing to use the app as if logged in as the user
 * Only works if the current or real user has the admin role
 *
 * @param userFragmentRef the user to mask into
 */
export async function masqAsUser(userFragmentRef: masq_masqAsUser$key | null): Promise<void> {
  const user = readInlineData(graphql`
    fragment masq_masqAsUser on User @inline {
      id
    }
  `, userFragmentRef)
  if (!user || isPrerendering()) return

  await commitMutation<masq_masqAsUserMutation>({
    mutation: graphql`
      mutation masq_masqAsUserMutation($input: MasqInput!) {
        masq(input: $input) {
          user {
            id

            # Refresh layout nav
            ...NavigationWrapper_User
          }
        }
      }
    `,
    variables: {
      input: {
        userId: user.id,
      },
    },
  })

  // TODO: fix soft reload issues, then reimplement it with updater function to the mutation
  // NOTE: there is as a bug that causes the profile autosave to overwrite another user's profile with soft reload
  hardReloadApp()
}

/**
 * Unmasks in case the current session has a real user and a current user that is different, meaning that the real
 * user has masked into the current user.
 *
 * In that case, this method will remove the mask and set the current user back to the original "real user"
 *
 * Otherwise, does nothing.
 */
export async function unmasq() {
  await commitMutation<masq_unmasqMutation>({
    mutation: graphql`
      mutation masq_unmasqMutation {
        unmasq(input: {}) {
          user {
            id

            # Refresh layout nav
            ...NavigationWrapper_User
          }
        }
      }
    `,
    variables: {},
  })

  // TODO: fix soft reload issues, then reimplement it with updater function to the mutation
  // NOTE: there is as a bug that causes the profile autosave to overwrite another user's profile with soft reload
  hardReloadApp()
}
